import { Link } from 'react-router-dom';
import React, { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import ghadminapi from '../api/ghadminapi';
import loginapi from '../api/login';
import { FaPlusCircle } from "react-icons/fa";
import { AiOutlineDownload } from "react-icons/ai";

import { APISERVERURL } from '../APIServerURL';
import Course from '../components/AdminCancelledBillCard';

function ViewAllCancelledBills({accessToken,setAccessToken, setRefreshFailed }) {
  const { ghCode } = useParams();
  const billType='';
  const navigate = useNavigate();
  const [registrationForms,setRegistrationForms]=useState([]);
  const [formListLoaded,setFormListLoaded]=useState(false);
  const [isDownloading,setIsDownloading]=useState(false);
 const [currentMonth,setCurrentMonth]=useState('ALL'); 
  const [currentYear,setCurrentYear]=useState('ALL'); 
  function downloadFile(fname)
  {
    fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
      response.blob().then((blob) => {         
          // Creating new object of PDF file
          const fileURL =
              window.URL.createObjectURL(blob);
               
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = fname;
          alink.click();
          setIsDownloading(false);
      });
    });
  }
const handleDownload=async (e)=>{
    setIsDownloading(true);
  e.preventDefault();
  try{
    //alert(img+" "+postId);
    //post request to deletePhoto wit {id,fileName}
    //setIsAppLoaded(false);
    const response= await ghadminapi.post('/downloadAllBills',{ billType,ghCode,currentMonth,currentYear},{headers:{'Authorization':`Bearer ${accessToken}`}});    
    alert(response.data);
    downloadFile(response.data);
  }
  catch(err)
  {
    if( err.response.status===403)
      {
        navigate(`/accessdenied`); 
      }
    try{
      const config = { withCredentials: true };
      const x=await loginapi.get('/getAccessToken',config);
      //alert(JSON.stringify(x['data']['accessToken']));
      
      const nat=x['data']['accessToken'];
      setAccessToken(nat);
      //console.log(`ne at ${nat}`);
      //console.log(`Second at:${accessToken}`);
      //alert('ok');
      try{       
        const response= await ghadminapi.post('/downloadAllBills',{ billType,ghCode,currentMonth,currentYear},{headers:{'Authorization':`Bearer ${nat}`}});    
        alert(JSON.stringify(response.data));
        downloadFile(response.data);
       }
       catch(err)
       {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        alert('unusual error newposts.js');
        //setIsAppLoaded(true);
        //alert(JSON.stringify(err));
        //navigate('/');
       }
    }
    catch(err)
    {
      alert(JSON.stringify(err));
      setIsDownloading(false);
      //setError(JSON.stringify(err));
      //navigate('/');
    }

  }
}


 
 
  const loadForms=async (currentMonth,currentYear)=>{
    setFormListLoaded(false);
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await ghadminapi.post('/getCancelledBills',{billType:billType,ghCode,currentMonth,currentYear},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      setRegistrationForms(response.data.registrationForms);
      setFormListLoaded(true);
      //alert(JSON.stringify(response.data));
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await ghadminapi.post('/getCancelledBills',{billType:billType,ghCode,currentMonth,currentYear},{headers:{'Authorization':`Bearer ${nat}`}});   
                      setRegistrationForms(response.data.registrationForms);
                      setFormListLoaded(true);
                      //alert(JSON.stringify(response.data));
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            ////setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
            setFormListLoaded(true);
          }
  }

  useEffect(() => {
    if (currentMonth && currentYear) {
      loadForms(currentMonth,currentYear);
    }
  }, [currentMonth, currentYear]);

  return (
    <main className="w-full">
     <div className="flex flex-col items-center w-full">


     <div className="w-full bg-red-100 relative py-1">
  {/* Heading */}
  
    <h1 className="text-2xl text-gray-400 text-center">ALL CANCELLED BILLS</h1>
  
</div>

<div className='w-full bg-blue-100 flex flex-col sm:flex-row gap-2 justify-center items-center py-2'>
<div className="flex flex-col items-center">
  <label htmlFor="month" className="text-sm text-gray-600">Select Month</label>
  <select
    id="month"
    value={currentMonth}
    onChange={(e) => {
      if (currentYear !== "ALL") {
        setCurrentMonth(e.target.value);
      }
    }}
    disabled={currentYear === "ALL"}
    className="px-3 py-1 rounded border border-gray-300 disabled:bg-gray-100 disabled:text-gray-500"
  >
    {[
      { value: '01', label: 'January' },
      { value: '02', label: 'February' },
      { value: '03', label: 'March' },
      { value: '04', label: 'April' },
      { value: '05', label: 'May' },
      { value: '06', label: 'June' },
      { value: '07', label: 'July' },
      { value: '08', label: 'August' },
      { value: '09', label: 'September' },
      { value: '10', label: 'October' },
      { value: '11', label: 'November' },
      { value: '12', label: 'December' },
      { value: 'ALL', label: 'All Months' },
    ].map(({ value, label }) => (
      <option key={value} value={value}>{label}</option>
    ))}
  </select>
</div>
  <div className="flex flex-col items-center">
  <label htmlFor="year" className="text-sm text-gray-600">Select Year</label>
  <select
    id="year"
    value={currentYear}
    onChange={(e) => {
      const selectedYear = e.target.value;
      setCurrentYear(selectedYear);
      if (selectedYear === "ALL") {
        setCurrentMonth("ALL");
      }
    }}
    className="px-3 py-1 rounded border border-gray-300"
  >
    {Array.from({ length: 11 }, (_, i) => 2024 + i).map((year) => (
      <option key={year} value={year}>{year}</option>
    ))}
    <option value="ALL">ALL YEARS</option>
  </select>
</div>

</div>

<div className='w-full bg-blue-100 flex flex-col sm:flex-row gap-2 justify-center items-center py-2'>
<div className='w-full flex flex-col items-center '>
<p># of Bills:</p>
<p className='font-bold'>{registrationForms.length||0}</p>
</div>

<div className='w-full flex flex-col items-center '>
<p >Total Amount:</p>
<p className='font-bold'>
    {registrationForms
      .reduce((sum, form) => sum + Number(form.total_amount || 0), 0)
      .toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}
  </p>
</div>

<div className='w-full flex flex-col items-center '>
<button
  onClick={handleDownload}
  className="flex items-center gap-2 px-4 py-2 text-white text-xs rounded-lg shadow-md transition duration-300 
             bg-orange-600 hover:bg-orange-700 m-1"
  disabled={isDownloading} // Optional: Disable while downloading
>
  {isDownloading ? (
    <span>PLEASE WAIT...</span>
  ) : (
    <>
      <AiOutlineDownload size={20} />
      ALL BILLS
    </>
  )}
</button>
</div>
</div>


         
        
        
          {formListLoaded && (
            <div className="w-full  mt-2 py-1 flex flex-wrap gap-4 justify-center items-center min-h-[150px]">
              {registrationForms.length > 0 ? (
                registrationForms.map((form) => <Course key={form._id} form={form} />)
              ) : (
                <p className="text-gray-600 text-sm">No bills to display</p>
              )}
            </div>
          )}

          
     </div>
    {
   (!formListLoaded) && <div className="w-[98%] max-w-[1200px]">
    Please wait!
    </div>
    }
    </main>
  );
  }
  
  export default ViewAllCancelledBills